module.exports = __webpack_public_path__ + "img/google_play.2bf9a550.svg";